<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ButtonAll from '../UI/Button/ButtonAll.vue'

const props = defineProps<{
  addresses: Address[]
}>()

const emit = defineEmits<{
  edit: [{ address: Address }]
}>()

const { t } = useI18n()

function editAddress(address: Address) {
  emit('edit', { address })
}
</script>

<template>
  <table class="table table-responsive table-striped mb-0">
    <thead>
      <tr>
        <th class="font-weight-bold col-2">
          {{ t('entity.information.addressList.registrationNumber') }}
        </th>
        <th class="font-weight-bold col-4">
          {{ t('entity.information.addressList.address') }}
        </th>
        <th class="font-weight-bold col-2">
          {{ t('entity.information.addressList.postalCode') }}
        </th>
        <th class="font-weight-bold col-2">
          {{ t('entity.information.addressList.city') }}
        </th>
        <th class="font-weight-bold col-2">
          {{ t('entity.information.addressList.country') }}
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="address in addresses" :key="address.id" data-test="address-list-item">
        <td data-test="address-list-item-registrationNumber">
          {{ address.siret ?? '-' }}
        </td>
        <td data-test="address-list-item-address">
          {{ address.address }}
        </td>
        <td data-test="address-list-item-postalCode">
          {{ address.postalCode }}
        </td>
        <td data-test="address-list-item-city">
          {{ address.city }}
        </td>
        <td data-test="address-list-item-country">
          {{ address.country }}
        </td>
        <td>
          <ButtonAll type="add" icon="modify" size="small" margin="no" @click="editAddress(address)" />
        </td>
      </tr>
      <tr v-if="addresses.length === 0" data-test="address-list-empty-row">
        <td colspan="6" class="text-center">
          {{ t('entity.information.addressList.empty') }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
